function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawOrderConfirmed = function UndrawOrderConfirmed(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1009.54 839.64",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 378.01,
    y1: 475.14,
    x2: 378.01,
    y2: 474.88,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 362.5,
    y1: 612.82,
    x2: 362.5,
    y2: 216.23,
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    d: "M586.55 111.4c-64.72-2.25-126.36-23.14-185.22-46S284.17 17.21 221 5.1c-40.63-7.79-87.1-8.89-119.83 12.89-31.51 21-41.69 57.15-47.16 90.73-4.12 25.26-6.54 51.85 4.74 75.49 7.84 16.42 21.74 30.22 31.36 45.95 33.47 54.72 9.81 122.2-26.45 175.63-17 25.07-36.75 49-49.88 75.66s-19.2 57.25-7.71 84.47c11.38 27 38.51 47.24 67.9 61.49 59.69 28.95 130 37.23 198.61 41.92 151.83 10.39 304.46 5.89 456.69 1.39 56.34-1.67 112.92-3.36 168.34-12.07 30.78-4.84 62.55-12.51 84.9-31.05 28.36-23.53 35.39-63.37 16.38-92.88-31.88-49.49-120-61.78-142.31-114.89-12.26-29.24.33-61.8 18.16-88.92 38.24-58.16 102.33-109.19 105.7-175.67 2.32-45.66-28.49-91.39-76.13-113-49.93-22.64-119.18-19.8-156 17.69-37.95 38.6-104.61 53.45-161.76 51.47z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 483.49,
    cy: 780.99,
    rx: 303.97,
    ry: 41.12,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("rect", {
    x: 642.8,
    y: 289.82,
    width: 8.86,
    height: 73.02,
    rx: 2.29,
    ry: 2.29,
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 348.37,
    y: 232.61,
    width: 4.97,
    height: 24.04,
    rx: 2.29,
    ry: 2.29,
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 348.19,
    y: 276.63,
    width: 5.6,
    height: 41.84,
    rx: 2.29,
    ry: 2.29,
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 348.28,
    y: 333.11,
    width: 5.33,
    height: 42.2,
    rx: 2.29,
    ry: 2.29,
    fill: "#3a3768"
  }), React.createElement("rect", {
    x: 351.18,
    y: 153.17,
    width: 296.4,
    height: 602.39,
    rx: 38.99,
    ry: 38.99,
    fill: "#3a3768"
  }), React.createElement("path", {
    d: "M605.77 168.82h-34v4.09a19.38 19.38 0 0 1-19.39 19.38H444.25a19.38 19.38 0 0 1-19.39-19.38v-4.09h-31.83a23.54 23.54 0 0 0-23.54 23.54v523.97a23.54 23.54 0 0 0 23.54 23.54h212.74a23.54 23.54 0 0 0 23.54-23.54V192.4a23.54 23.54 0 0 0-23.54-23.58z",
    fill: primaryColor
  }), React.createElement("rect", {
    x: 470.79,
    y: 171.16,
    width: 41.39,
    height: 8.4,
    rx: 3.87,
    ry: 3.87,
    fill: "#e6e8ec"
  }), React.createElement("circle", {
    cx: 523.21,
    cy: 175.36,
    r: 4.77,
    fill: "#e6e8ec"
  }), React.createElement("path", {
    d: "M750.2 126.75s-84.2-5.08-74.28 53.92c0 0-2 10.43 7.48 15.16 0 0 .15-4.37 8.64-2.88a39.5 39.5 0 0 0 9.15.44 19.06 19.06 0 0 0 11.18-4.57s23.67-9.78 32.87-48.46c0 0 6.81-8.44 6.54-10.61l-14.21 6.07s4.86 10.25 1 18.77c0 0-.46-18.4-3.19-18-.55.08-7.38 3.55-7.38 3.55s8.35 17.85 2.05 30.83c0 0 2.39-22-4.66-29.54l-10 5.84s9.76 18.44 3.14 33.49c0 0 1.7-23.08-5.25-32.07l-9.06 7.07s9.17 18.17 3.58 30.65c0 0-.73-26.86-5.54-28.89 0 0-7.93 7-9.14 9.86 0 0 6.28 13.2 2.38 20.16 0 0-2.39-17.9-4.35-18 0 0-7.9 11.86-8.72 20 0 0 .34-12.09 6.81-21.12 0 0-7.64 1.31-12.1 6.26 0 0 1.23-8.38 14.05-9.12 0 0 6.53-9 8.27-9.54 0 0-12.74-1.07-20.47 2.36 0 0 6.8-7.91 22.81-4.31l8.95-7.31s-16.78-2.29-23.9.24c0 0 8.19-7 26.31-1.9l9.74-5.82s-14.31-3.08-22.83-2c0 0 9-4.85 25.69.41l7-3.13s-10.48-2.06-13.55-2.39-3.23-1.17-3.23-1.17a36.35 36.35 0 0 1 19.69 2.19s14.78-5.51 14.53-6.44zM663.83 100.51s-38-2.29-33.56 24.37c0 0-.89 4.71 3.38 6.85 0 0 .07-2 3.91-1.31a17.51 17.51 0 0 0 4.13.2 8.56 8.56 0 0 0 5.05-2.08s10.7-4.42 14.86-21.9c0 0 3.07-3.81 2.95-4.79l-6.42 2.74s2.19 4.63.47 8.48c0 0-.21-8.31-1.44-8.12-.25 0-3.34 1.61-3.34 1.61s3.78 8.07.93 13.93c0 0 1.08-9.94-2.11-13.35l-4.52 2.68s4.41 8.33 1.42 15.13c0 0 .77-10.43-2.37-14.49l-4.09 3.2s4.14 8.21 1.62 13.85c0 0-.34-12.14-2.51-13.06 0 0-3.58 3.16-4.13 4.46 0 0 2.84 6 1.08 9.11 0 0-1.08-8.09-2-8.13 0 0-3.57 5.36-3.94 9a19.52 19.52 0 0 1 3.08-9.54 10.76 10.76 0 0 0-5.47 2.83s.56-3.79 6.35-4.12c0 0 3-4.07 3.74-4.32 0 0-5.76-.48-9.25 1.07 0 0 3.07-3.57 10.3-1.95l4-3.3s-7.59-1-10.8.11c0 0 3.7-3.16 11.89-.86l4.4-2.63s-6.47-1.39-10.32-.89c0 0 4.07-2.19 11.61.18l3.15-1.41s-4.74-.93-6.13-1.08-1.46-.53-1.46-.53a16.39 16.39 0 0 1 8.9 1s6.76-2.52 6.64-2.94z",
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 864.17,
    cy: 773.34,
    rx: 26.93,
    ry: 4.55,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 91.09,
    cy: 810.68,
    rx: 26.93,
    ry: 4.55,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 195.26,
    cy: 835.09,
    rx: 26.93,
    ry: 4.55,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 805.22,
    cy: 822.1,
    rx: 40.21,
    ry: 6.8,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M821.85 810.98a11.71 11.71 0 0 0 3.83-5.79c.5-2.29-.48-5-2.68-5.89-2.46-.94-5.09.77-7.08 2.49s-4.28 3.69-6.89 3.32a10.48 10.48 0 0 0 3.25-9.81 4.13 4.13 0 0 0-.91-2c-1.36-1.46-3.84-.84-5.47.32-5.2 3.65-6.65 10.72-6.68 17.07-.53-2.29-.08-4.68-.1-7s-.65-5-2.64-6.23a7.94 7.94 0 0 0-4-.94c-2.34-.09-4.94.15-6.54 1.86-2 2.12-1.46 5.68.26 8s4.35 3.81 6.77 5.42a15 15 0 0 1 4.83 4.61 4.16 4.16 0 0 1 .36.83h14.61a41.06 41.06 0 0 0 9.08-6.26zM196.65 723.27s5.5 7.19-2.53 18-14.65 20-12 26.77c0 0 12.12-20.15 22-20.43s3.38-12.22-7.47-24.34z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M196.65 723.27a8.83 8.83 0 0 1 1.12 2.26c9.62 11.3 14.75 21.85 5.5 22.11-8.61.25-18.94 15.65-21.42 19.54.08.3.18.59.29.89 0 0 12.12-20.15 22-20.43s3.36-12.25-7.49-24.37z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M206.86 732.43c0 2.53-.28 4.58-.63 4.58s-.63-2.05-.63-4.58.35-1.34.7-1.34.56-1.19.56 1.34z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M210.37 735.45c-2.22 1.21-4.16 1.94-4.32 1.63s1.49-1.54 3.71-2.75 1.35-.33 1.51 0 1.32-.09-.9 1.12z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M167.64 723.27s-5.5 7.19 2.53 18 14.65 20 12 26.77c0 0-12.11-20.15-22-20.43s-3.4-12.22 7.47-24.34z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M167.64 723.27a9 9 0 0 0-1.13 2.26c-9.62 11.3-14.74 21.85-5.5 22.11 8.62.25 18.95 15.65 21.43 19.54a7.76 7.76 0 0 1-.3.89s-12.11-20.15-22-20.43-3.37-12.25 7.5-24.37z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M157.42 732.43c0 2.53.29 4.58.64 4.58s.63-2.05.63-4.58-.35-1.34-.7-1.34-.57-1.19-.57 1.34z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M153.92 735.45c2.22 1.21 4.15 1.94 4.32 1.63s-1.5-1.54-3.72-2.75-1.34-.33-1.51 0-1.31-.09.91 1.12z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M159.17 767.13s15.36-.48 20-3.77 23.63-7.24 24.77-1.95 23.09 26.29 5.75 26.43-40.3-2.7-44.92-5.51-5.6-15.2-5.6-15.2z",
    fill: "#a8a8a8"
  }), React.createElement("path", {
    d: "M209.99 786c-17.34.14-40.3-2.7-44.92-5.51-3.51-2.15-4.92-9.84-5.39-13.38h-.51s1 12.38 5.59 15.2 27.58 5.65 44.92 5.51c5 0 6.73-1.82 6.64-4.46-.7 1.62-2.61 2.61-6.33 2.64z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M377.46 474.88a.92.92 0 0 0 1.09.14 3.86 3.86 0 0 1-1.09-.14z",
    transform: "translate(-95.23 -30.18)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M497.29 275.88c-2.11-.62-5.11-1.63-8.74-2.9a46.83 46.83 0 0 0 8.1-16.53l-.31.12c.1-.37.21-.73.31-1.1-6.94 2.86-14.63-2-19.52-8.21s-8.22-13.94-13.57-19.67a62.7 62.7 0 0 0-7.19-6.27c-1.58-1.24-3.29-2.53-5.22-2.59-3.12-.09-5.57 3-8.58 3.93a11.62 11.62 0 0 1-6-.22c-7.77-1.81-15.26-5.14-23.15-6a26.75 26.75 0 0 0-12.56 1.43c-4 1.54-5.8 4.59-9 7-3.47 2.62-10.38 2.56-14.47 3a103.62 103.62 0 0 1-14.94.63 33.88 33.88 0 0 0-8.6.32c-5.94 1.32-10.71 6.1-15.16 10.7a8 8 0 0 0-2.51 4 5.31 5.31 0 0 0 0 1.32 8.59 8.59 0 0 0 .6 3.5 46.41 46.41 0 0 0 5.7 11.66c1.82 2.64 3.93 5.12 5 8.24a16.23 16.23 0 0 1 .77 4.75 36.43 36.43 0 0 1-.53 5.11 65 65 0 0 1-3.85 13.59c-.94 2.32-2 4.63-2.25 7.17a12.94 12.94 0 0 0 0 1.52c-.3 7.83 7.51 13.48 9 21.27a14.19 14.19 0 0 1 .22 1.95c-.17 4.86-2.9 9.61-6.92 11.49.35.14.71.26 1.07.39a11.24 11.24 0 0 1-1.07.6c.73.28 1.48.52 2.24.74A52.62 52.62 0 0 0 334.75 351c-13.46 25.53-105.2 75.61-105.2 75.61s.52.29 1.36.79c-.34.21-.7.45-1.1.72-7.94 5.36-26.58 21-9.73 40.72 0 0 13.15-21.05 22.36-30 .42-.4.82-.77 1.21-1.12a2.73 2.73 0 0 1 .36 2.16l60.33-34.37s21.44-15.22 27.42-18.66c2.06-1.18 7.31-4.46 13.59-5.91l-.7.31a27.15 27.15 0 0 1 6.92-1c10.68.17 22.24 8.1 26.06 39.51 5.11 42.06 2.74 49.64 1.1 50.68a2.88 2.88 0 0 1-.6-.11.9.9 0 0 0 .16.12 2.9 2.9 0 0 1-.66-.12.92.92 0 0 0 .88.22.86.86 0 0 0 .67-.08h.81c0 .38-.06.78-.09 1.17-.08 0-.48.23 0 .26-.12 2.37-.11 5 0 7.65-5.31.3-10.61.62-15.26.91l.42-2.23.19-1c4.07-.33 7.94-1.54 8.39-4.9 1-7.36-9-11.29-17.45-11.78s-59.33 2.95-59.33 2.95-7.63 10 16.56 13.11c.72.38 1.47.8 2.23 1.24 9.47 5.48 22.33 15.56 28.48 20.53l.86.69-2.76 2.23c15 3.44 29.42 61.38 37.39 87.89s25.43 25.53 39.89 21.61c13.55-3.69 15.28-43.58 15.44-48.59v-.51l24.09 30.11 1.83 2.29c.71.37 1.4.72 2.08 1.05 18.25 8.81 38.41-8.07 32.67-27.27-5.79-19.4-14.79-48.07-20.79-60.19-5-10.15-11.51-27-15.45-37.58a13.85 13.85 0 0 0 1.49-.72s-.09-.47-.25-1.34l.25-.13s-5.8-30.55-6.12-52.24v-1.14-.71c4.36-1 7.12-1.4 7.12-1.4l.08-.94-.51.11 2.42-28.14s8.9-19.19 2.09-27.19a17 17 0 0 1-4-8.31c-1.14-7.36 0-19.61 15.87-29.8 24.43-15.71 33.91-28.48 33.91-28.48s.52-9.38-14.44-13.8zm-48.52 19.52v-13c4.53-.22 9.16.31 13.71 0a34.57 34.57 0 0 0 6.62-1.12l1.1.77a120.72 120.72 0 0 1-21.43 13.35zm-69.26 203.81c1.79 1.26 3.59 2.57 5.36 3.88 1.1 6.41 2.07 10.94 2.14 11.25a90.24 90.24 0 0 0-7.5-15.13z",
    transform: "translate(-95.23 -30.18)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    d: "M323.44 460.82l-1.08 5.86-.83 4.48-1.51 8.2-14.64 10.25s-1.32-1.13-3.5-2.91c-6-4.94-18.61-15-27.87-20.4a31.19 31.19 0 0 0-7.66-3.53z",
    fill: "#ffbdc6"
  }), React.createElement("path", {
    d: "M323.44 460.82l-1.08 5.86a45.73 45.73 0 0 1-9.66-.5l-34.16.49c-1.61-.1-3.12-.22-4.53-.37a31.19 31.19 0 0 0-7.66-3.53z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M312.7 465.18s17.07 2.93 18.07-4.36-8.79-11.23-17.08-11.72-58.07 2.93-58.07 2.93-8.78 11.71 22.93 13.67z",
    fill: "#474463"
  }), React.createElement("path", {
    d: "M323.44 460.82l-1.08 5.86-.83 4.48-1.51 8.2-14.64 10.25s-1.32-1.13-3.5-2.91c-6-4.94-18.61-15-27.87-20.4a31.19 31.19 0 0 0-7.66-3.53z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M323.44 460.82l-1.08 5.86a45.73 45.73 0 0 1-9.66-.5l-34.16.49c-1.61-.1-3.12-.22-4.53-.37a31.19 31.19 0 0 0-7.66-3.53z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M312.7 465.16s17.08 2.92 18.06-4.4-8.79-11.22-17.08-11.71-58.07 2.93-58.07 2.93-8.78 11.71 22.93 13.66z",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#474463",
    d: "M260.73 224.62h89.3v105.89h-89.3z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M260.73 225.1h89.3v105.89h-89.3z"
  }), React.createElement("path", {
    d: "M156.07 405.89c-1.47.37-3.35 1.79-5.44 3.85-9 8.91-21.89 29.82-21.89 29.82-16.48-19.63 1.76-35.14 9.53-40.47 1.89-1.29 3.16-2 3.16-2zM322.46 258.04s4.39 30.74 19.52 38.06-19.52 21-19.52 21l-47.33-17.58s26.84-8.79 21.47-34.65zM271.71 442.98l-1.07 5.84-.87 4.5-1.51 8.2-14.64 10.24s-1.32-1.12-3.5-2.9c-6-4.94-18.61-15-27.88-20.4a31 31 0 0 0-7.66-3.53z",
    fill: "#ffbdc6"
  }), React.createElement("path", {
    d: "M271.71 442.98l-1.07 5.84a45.73 45.73 0 0 1-9.66-.5l-34.16.49c-1.61-.1-3.13-.22-4.54-.37a31 31 0 0 0-7.66-3.53z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M260.98 447.37s17.08 2.92 18.05-4.39-8.78-11.23-17.08-11.72-58.06 2.93-58.06 2.93-8.79 11.71 22.93 13.67z",
    fill: "#474463"
  }), React.createElement("path", {
    d: "M269.77 453.32l-1.51 8.2-14.64 10.24s-1.32-1.12-3.5-2.9l19.36-15.88z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M366.46 565.03c-.67-.33-1.34-.67-2-1l-1.8-2.27-23.61-29.94v.52c-.16 5-1.86 44.62-15.12 48.28-14.15 3.9-31.22 4.88-39-21.47s-22-83.93-36.6-87.35l21.72-17.81s14.38 16.82 20.24 32.92c-.22-1-10.15-47.4-2-55.61h71.25s11 31.33 18.54 46.85c5.87 12.05 14.68 40.54 20.35 59.82 5.62 19.04-14.11 35.85-31.97 27.06z",
    fill: "#474463"
  }), React.createElement("path", {
    d: "M364.43 440.05c-11 6.51-59.29 3.86-75 2.8l-4.28-.31c-.46 0 .07-.26.07-.26l.44-4.43 11.71-29.76 62.7-36.36c-1.27 3.83-1.69 9.69-1.59 16.4.29 21.56 5.95 51.92 5.95 51.92z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M364.43 438.58c-11 6.51-59.29 3.86-75 2.8l-4.28-.3-.71-.06.78-.2 3.86-1 8.29-33.18 62.7-36.35c-1.27 3.83-1.69 9.69-1.59 16.4.29 21.54 5.95 51.89 5.95 51.89z",
    fill: "#f2f1f2"
  }), React.createElement("path", {
    d: "M358.44 386.67c-12.75 2.94-40.81 11.57-51.59 32.4-7.19 13.87-13.24 19.82-17.46 22.31l-4.28-.3a2.5 2.5 0 0 0 .07-.26l3.86-1 8.29-33.18 62.7-36.35c-1.26 3.81-1.69 9.67-1.59 16.38zM141.43 397.11l14.64 8.78c-1.47.37-3.35 1.79-5.44 3.85-1.22-3.56-8.88-8.53-12.36-10.65 1.89-1.27 3.16-1.98 3.16-1.98zM282.5 441.65a.87.87 0 0 1-1-.14 3.47 3.47 0 0 0 1 .14z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M315.63 294.15s-13.18 1.46-22.45-8.3c0 0-39 11.23-52.21 36.6s-103 75.15-103 75.15 15.62 8.78 14.15 13.17l59.05-34.16s21-15.12 26.83-18.54 38.07-24.4 44.9 32.69 0 50.26 0 50.26 9.76 3.42 23.91-23.91 58.06-33.67 58.06-33.67l2.44-28.78s8.71-19.08 2-27a17 17 0 0 1-3.91-8.26c-1.11-7.31 0-19.49 15.54-29.61 23.91-15.62 33.18-28.3 33.18-28.3s.49-9.28-14.15-13.67-74.17-28.3-74.17-28.3l-2 8.3 46.97 33.15s-23.42 19-42 18.54c0 0 3.45 14.15-13.14 14.64z",
    fill: "#ff748e"
  }), React.createElement("path", {
    d: "M324.67 271.42a95.3 95.3 0 0 1-2.7-11.92l-25.86 6.83a28.35 28.35 0 0 1-.59 14.92 27.81 27.81 0 0 0 29.15-9.83z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 303.19,
    cy: 252.92,
    r: 27.81,
    fill: "#ffbdc6"
  }), React.createElement("path", {
    d: "M317.98 189.67c7.72.87 15.05 4.19 22.65 6a11.24 11.24 0 0 0 5.86.23c2.95-.92 5.35-4 8.41-3.91 1.88 0 3.55 1.34 5.1 2.57a61.75 61.75 0 0 1 7 6.24c5.24 5.69 8.49 13.35 13.27 19.54s12.32 11 19.11 8.16c-4.62 18-19.75 31.71-36.12 32.83-6.53.44-13.22-.92-19.54 1a17.26 17.26 0 0 1-4.93 1.2c-3.64 0-6.57-3.34-8.84-6.59-5.32-7.64-9.53-16.32-15.52-23.29-2-2.3-4.31-4.49-7.11-4.91s-5.37.91-7.86 2.2c-4.11 2.13-8.31 4.34-11.5 8s-5.2 9.1-3.88 14c.71 2.66 2.33 5.06 2.36 7.84.06 4.43-3.86 7.68-4.63 12a45.08 45.08 0 0 0-.19 5.46c-.34 5.92-4.21 10.77-8.25 14.49-1.58 1.45-3.32 3-3.78 5.24-.31 1.52 0 3.14-.2 4.68-.59 3.84-4.42 5.79-7.81 6.3a22.73 22.73 0 0 1-11.72-1.39c4.74-2.25 7.66-8.62 6.56-14.34-1.51-7.92-9.47-13.6-8.79-21.67a25.21 25.21 0 0 1 2.2-7.13 65.06 65.06 0 0 0 3.76-13.5c.6-3.58.89-7.37-.23-10.77-1-3.11-3.09-5.57-4.86-8.19a46.47 46.47 0 0 1-5.63-11.54 8 8 0 0 1-.54-3.81 7.84 7.84 0 0 1 2.45-4c4.35-4.57 9-9.33 14.83-10.63a32.93 32.93 0 0 1 8.42-.33 98 98 0 0 0 14.63-.62c4-.47 10.76-.4 14.15-3 3.16-2.43 4.94-5.46 8.83-7a25.82 25.82 0 0 1 12.34-1.36zM333.44 476.89s16.1 31.72 11.22 41.47M362.63 561.72l-23.58-29.9v.52s-1.36-9.68 3.13-6.43c9.84 7.12 25.58 18.79 25.92 20.8s-3.19 10.04-5.47 15.01z",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M329.29 279.51s2 8.24-4.44 12.36c9.9-1.69 10.34-9.4 10-12.75a31.41 31.41 0 0 1-5.56.39zM143.87 395.64s89.78-49.77 103-75.14c9.45-18.21 32.23-29.13 44.33-33.85-8.82 3-38.54 14.31-49.7 35.8-13.17 25.37-103 75.15-103 75.15zM346.77 275.63c15.28-4.75 29.88-16.61 29.88-16.61l-46.88-33.2 1.07-4.54-4.49-1.8-1.95 8.3 46.85 33.18a113.2 113.2 0 0 1-24.48 14.67zM347.04 388.08a116.55 116.55 0 0 1 18.36-4.64l.08-.94a124.5 124.5 0 0 0-18.44 5.58zM290.26 439.2h-.43a.88.88 0 0 1-1-.14 3.51 3.51 0 0 0 1 .14c1.6-.93 4-8.22-1-50.4-5.38-45-26.55-41.49-38.13-36.31 11.84-3.26 28.13-.44 32.76 38.26 5.05 42.18 2.64 49.47 1 50.4a10.81 10.81 0 0 0 5.8-1.95zM284.46 441.16a3.51 3.51 0 0 1-1-.14.88.88 0 0 0 1 .14z"
  })), React.createElement("path", {
    d: "M317.98 188.69c7.72.88 15.05 4.19 22.65 6a11.24 11.24 0 0 0 5.86.22c2.95-.91 5.35-4 8.41-3.91 1.88.06 3.55 1.34 5.1 2.57a62.73 62.73 0 0 1 7 6.24c5.24 5.69 8.49 13.35 13.27 19.54s12.32 11 19.11 8.16c-4.62 18-19.75 31.71-36.12 32.83-6.53.45-13.22-.91-19.54 1a16.93 16.93 0 0 1-4.93 1.2c-3.64 0-6.57-3.34-8.84-6.59-5.32-7.64-9.53-16.31-15.52-23.28-2-2.31-4.31-4.5-7.11-4.92s-5.37.92-7.86 2.21c-4.11 2.13-8.31 4.33-11.5 8s-5.2 9.09-3.88 14c.71 2.66 2.33 5.06 2.36 7.84.06 4.44-3.86 7.68-4.63 12a45 45 0 0 0-.19 5.46c-.34 5.92-4.21 10.76-8.25 14.49-1.58 1.44-3.32 3-3.78 5.23-.31 1.53 0 3.14-.2 4.69-.59 3.84-4.42 5.79-7.81 6.29a22.53 22.53 0 0 1-11.72-1.39c4.74-2.24 7.66-8.62 6.56-14.33-1.51-7.92-9.47-13.61-8.79-21.67a25.11 25.11 0 0 1 2.2-7.13 65.32 65.32 0 0 0 3.76-13.51c.6-3.57.89-7.36-.23-10.77-1-3.1-3.09-5.57-4.86-8.19a46.57 46.57 0 0 1-5.63-11.53 8.11 8.11 0 0 1-.54-3.82 7.88 7.88 0 0 1 2.45-3.95c4.35-4.57 9-9.32 14.83-10.63a33.38 33.38 0 0 1 8.42-.32 99.38 99.38 0 0 0 14.63-.62c4-.47 10.76-.41 14.15-3 3.16-2.42 4.94-5.46 8.83-7a26 26 0 0 1 12.34-1.41z",
    fill: "#474463"
  }), React.createElement("circle", {
    cx: 501.19,
    cy: 461.76,
    r: 56.07,
    fill: "#fff"
  }), React.createElement("path", {
    d: "M574.86 454.37a74.94 74.94 0 1 1-74.94-74.94 74.94 74.94 0 0 1 74.94 74.94zm-83.6 39.67l55.59-55.59a4.83 4.83 0 0 0 0-6.84l-6.84-6.79a4.82 4.82 0 0 0-6.83 0l-45.34 45.34-21.17-21.22a4.85 4.85 0 0 0-6.84 0l-6.84 6.88a4.85 4.85 0 0 0 0 6.84l31.43 31.42a4.83 4.83 0 0 0 6.84 0z",
    fill: "#3acc6c"
  }));
};
UndrawOrderConfirmed.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawOrderConfirmed;